const serverTomcatConfig = {
  statusBar: {
    visibility: true,
    messgae: "UnderDevelopmentStatusBand",
    color: "red"
  },
  backend: {
    url: "https://testapi.rebelskool.com/"
  },
  apps: {
    url: "https://testapps.rebelskool.com/"
  },
  annualReport: {
    url: "https://testapps.rebelskool.com/annualreport"
  },
  annualReportWithHash: {
    url: "https://testapps.rebelskool.com/#/annualreport"
  },
  corporatePage: {
    url: "https://test.rebelskool.com/"
  },
  SRU: {
    url: "https://testapps.rebelskool.com/income-declaration-2"
  },
  NE: {
    url: "https://testapps.rebelskool.com/income-declaration-1"
  },
  forAccountingCompanies: {
    url: "https://testapps.rebelskool.com/for-accounting-companies"
  },
  microsoftBusinessCentral: {
    url: "https://testapps.rebelskool.com/microsoft-business-central-development"
  },
  ContactUs: {
    uploadFileSizeLimit: 2
  },
  Skatteverket: {
    environment: "testEnvironment"
  }
};

export default serverTomcatConfig;
